import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import ServicesSection from "./components/ServicesSection";
import CTASection from "./components/CTASection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import FloatingContact from "./components/FloatingContact";

export default function Home() {
  return (
    <main className="font-sans">
      <Navbar />
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <CTASection />
      <ContactSection />
      <Footer />
      <FloatingContact />
    </main>
  );
}
